// Module-level store for X-Usage-Remaining / X-Usage-Limit headers.
// Lives outside the React tree so the Axios interceptor can write to it directly.
// Components read it via useSyncExternalStore through useUsageWarning().

export type UsageCategory = 'tools' | 'api-lab'

export interface UsageState {
  remaining: number
  limit: number
  category: UsageCategory | null
}

let state: UsageState = { remaining: 0, limit: 0, category: null }
const subscribers = new Set<() => void>()

export function setUsage(remaining: number, limit: number, category: UsageCategory): void {
  state = { remaining, limit, category }
  subscribers.forEach((fn) => fn())
}

export function getUsageSnapshot(): UsageState {
  return state
}

export function subscribeToUsage(fn: () => void): () => void {
  subscribers.add(fn)
  return () => subscribers.delete(fn)
}
